<template>
  <div id="page">
    <van-nav-bar
      title="申请记录"
      left-text=""
      left-arrow
      @click-left="onClickLeft()"
    >
    </van-nav-bar>
    <div class="table-container">
      <div id="table">
        <div class="tbHeadFix">
          <div class="theadDiv" id="theadDiv">
            <table cellpadding="0" cellspacing="0">
              <thead>
                <tr>
                  <th align="center" style="width: 40%">
                    <div class="col">内容</div>
                  </th>
                  <th align="center" style="width: 20%">
                    <div class="col">状态</div>
                  </th>
                  <th align="center" style="width: 20%">
                    <div class="col">时间</div>
                  </th>
                  <th align="center" style="width: 20%">
                    <div class="col">操作</div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="tbodyDiv" id="tbodyDiv">
            <table border="0" cellpadding="0" cellspacing="0">
              <tbody>
                <tr v-for="(item, idx) in logList" v-bind:key="idx">        
                  <td align="center" style="width: 40%">
                    <div class="col">{{item.Remark}}</div>
                  </td>
                  <td align="center" style="width: 20%">
                    <div class="col">{{item.StatusDesc}}</div>
                  </td>
                  <td align="center" style="width: 20%">
                    <div class="col">{{item._CreateTime}}</div>
                  </td>
                  <td align="center" style="width: 20%">
                    <div class="col" v-if="item.CanDOPass==1">
                      <van-button round type="danger" size="mini" @click="DoPass(item.ID)"
                        >同意</van-button
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { NavBar, Button } from "vant";
export default {
  data() {
    return {
      logList: [],
    };
  },
  created() {
    this.QueryApplyLog();
  },
  mounted() {
    document.getElementById("tbodyDiv").onscroll = function (e) {
      document.getElementById("theadDiv").scrollLeft = e.target.scrollLeft;
    };
  },
  methods: {
    QueryApplyLog() {
      var that = this;
      this.$http.get("Team/QueryApplyLog").then((res) => {
        console.log(res);
        that.logList = res.data.ListData;
        that.logList.map(item=>{
          item.StatusDesc =item.Status==1?"已完成":"进行中";
        })
      });
      
    },
    DoPass(id){
      var that = this;
      this.$http.get("Team/DoPass?logId="+id).then((res) => {
        console.log(res);
        if(res.data=='success'){
          that.$toast("操作成功");
          that.QueryApplyLog();
        }else{
          that.$toast(res.data);
        }
      });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
  },
};
</script>
<style scoped>
html {
  background: #f12416;
}
#page {
  width: 100%;
  height: 100%;
}
.indexPage {
  width: 100%;
  height: 100%;
  background-image: url("../assets/draw3/index.jpg");

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-content: space-around;
  justify-content: center;
  flex-wrap: wrap;
}
.mockTap {
  width: 280px;
  height: 280px;
  padding-top: 70px;
}
.step {
  z-index: 999;
}

.bounce-in-top {
  -webkit-animation: bounce-in-top 1.2s ease-in both;
  animation: bounce-in-top 1.2s ease-in both;
}
/* ----------------------------------------------
 * Generated by Animista on 2021-9-5 1:36:2
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation bounce-in-top
 * ----------------------------------------
 */
@-webkit-keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
@keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
</style>
<style scoped>
.table-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
}

#table {
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
}

.tbHeadFix {
  height: 100%;
  font-size: 13px;
}

.theadDiv {
  display: flex;
  align-items: center;
  width: 100%;
  height: 45px;
  overflow: hidden;
  background-color: #f1f1f1;
}

.tbodyDiv {
  width: 100%;
  overflow: auto;
}

table {
  height: 100%;
  width: 100%;
}

th {
  height: 45px;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.col {
  padding: 5px 5px;
  box-sizing: border-box;
}

td {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
</style>
